// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2hScm","content":"styles_content__k5GPp","checkbox":"styles_checkbox__2uQSJ","checkboxLabel":"styles_checkboxLabel__3wc_z"};